import { Grid } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/GalleryProgressLine/GalleryProgressLine.styles';
import ProgressBar from '@components/Progress/ProgressBar';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
type PropsType = {
  actualCount?: number;
  maxCount: number;
};
const GalleryProgressLine = ({
  actualCount = 0,
  maxCount
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  return <>
      <Grid columns={1} sx={styles.visibleCount}>
        {actualCount} {t('of')} {maxCount} {getInflectedTranslation(maxCount, 'arrangement')}
      </Grid>
      <ProgressBar actualCount={actualCount} maxCount={maxCount} />
    </>;
};
export default GalleryProgressLine;